import { render, staticRenderFns } from "./CollectionMarcTable.vue?vue&type=template&id=5fbd94a3&"
import script from "./CollectionMarcTable.vue?vue&type=script&lang=ts&"
export * from "./CollectionMarcTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
